import styled from 'styled-components';

export const ActivitiesWrapper = styled.div`
  background: #ffffff;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 2px 12px 0 rgba(25,51,77,0.06);
`;

export const ActivitiesTitle = styled.h2`
  font-size: 1.1rem;
  font-weight: 700;
  color: #223046;
  margin: 4px 0 12px 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const QuickTiles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
`;

export const Tile = styled.div`
  background: #FFFCF4;
  border: 1.5px solid #F3F4F6;
  border-radius: 10px;
  padding: 20px 16px;
  text-align: center;
`;

export const TileLabel = styled.div`
  color: #223046;
  font-weight: 700;
`;

export const TileSub = styled.div`
  color: #6B7280;
  font-size: 0.95rem;
`;

export const EventsTitle = styled.h3`
  font-size: 1rem;
  color: #223046;
  margin: 6px 0 10px 0;
`;

export const EventList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const EventItem = styled.li`
  background: #F8FAFC;
  border: 1.5px solid #E7EAEE;
  border-radius: 10px;
  padding: 10px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const EventName = styled.span`
  color: #223046;
  font-weight: 600;
`;

export const EventDate = styled.span`
  background: #E9EEF5;
  color: #223046;
  border-radius: 14px;
  padding: 2px 10px;
  font-weight: 700;
  font-size: 0.85rem;
`;


